import React, { useState, useEffect } from 'react';
import axios from "axios";
import { GetServiceCaller } from '../services/serviceCaller';
import Select from 'react-select';

const DropdownValue = (props) => {
    const [options, setOptions] = useState([]);
    const [selectedName,setSelectedName]=useState('');

    const fetchOptions = async () => {
        try {
            const response = await GetServiceCaller(props.url);
            const options = response.data.map(record => ({
                value: record.value,
                label: record.text
            }));
            // setOptions(options);
            let selected = options.find(o=>o.value==props.value);
        
            setSelectedName(selected.label);
            
        } catch (error) {
            console.error("Error fetching code options:", error);
        }
    };
    useEffect(() => {
        fetchOptions();
    }, []);
    const handleDropdownChange = (e,name) => {
        props.handleDropdownChange(e,name);
    }
    return (
        <>
        <dt className='col-sm-6 text-start'>{selectedName}</dt>
        </>
    )
}
export default DropdownValue;

